import { ref } from 'vue';

let activeMediaViewerCloser = null;

// Aceleres: no telemovel, "Responder" no visor de midia mantem a foto aberta
// (como no WhatsApp) e o compositor real da conversa sobe por cima do visor
// enquanto isto estiver ligado. O GalleryView liga e desliga; o MessagesView
// so le para ajustar o z-index do compositor.
export const galleryReplyOpen = ref(false);

export const registerMediaViewer = closer => {
  activeMediaViewerCloser = closer;
};

export const unregisterMediaViewer = closer => {
  if (activeMediaViewerCloser === closer) {
    activeMediaViewerCloser = null;
  }
};

export const closeActiveMediaViewer = () => {
  if (!activeMediaViewerCloser) return false;

  activeMediaViewerCloser();
  return true;
};

/**
 * Aceleres: para onde voltar depois de fechar a mídia aberta pelo painel de
 * contato.
 *
 * Abrir uma foto/vídeo desmonta o painel (ver
 * ContactInfo.openInConversationViewer), e com ele morre o estado do modal de
 * mídias. Sem esta memória, quem entrou pela lista "todas as mídias" voltava
 * para a ficha do contato em vez da lista de onde saiu.
 *
 * O destino é consumido uma única vez e só vale para a mesma conversa — assim
 * um retorno pendente esquecido não abre o modal numa conversa qualquer.
 */
let pendingContactMediaReturn = null;

export const setContactMediaReturn = target => {
  pendingContactMediaReturn = target || null;
};

export const takeContactMediaReturn = conversationId => {
  const target = pendingContactMediaReturn;
  pendingContactMediaReturn = null;

  if (!target) return null;
  if (String(target.conversationId) !== String(conversationId)) return null;

  return target;
};
